// extracted by mini-css-extract-plugin
export default {"controlDiv":"control_controlDiv__21A2Z","addIcon":"control_addIcon__tahLB"};